"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountWebSocket = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
const DWUtils_1 = require("../Tools/DWUtils");
const TradeUtils_1 = require("../Tools/TradeUtils");
const BaseWebSocket_1 = require("./BaseWebSocket");
const types_1 = require("./types");
const smartTriggerOrderTypeList = ["draw_line_order"];
class AccountWebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor(config) {
        super(config);
    }
    emitData(type, data) {
        this.subject.next({ type: type, data: data });
    }
    open(exchange, channel) {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        // 在retry里面获取token，解决重连时token过期的问题
        this.subscription = (0, trade_utils_lib_1.requestWithRetry)(() => {
            console.log("open account websocket");
            this.connectCount++;
            this.connectionState = trade_utils_lib_1.State.ING;
            if (this.firstConnectTime === 0) {
                this.firstConnectTime = Date.now();
            }
            return (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.mergeMap)((token) => {
                let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountWebSocketHost}/user?tk=${token}`;
                if (exchange) {
                    url = `${url}&exchange=${exchange}`;
                }
                if (channel) {
                    url = `${url}&channel=${channel}`;
                }
                return this.createWebSocket(url);
            }))
                .pipe((0, operators_1.concatMap)((data) => {
                if (!data) {
                    return (0, rxjs_1.of)(undefined);
                }
                const type = data.channel;
                if (!type) {
                    return (0, rxjs_1.of)(undefined);
                }
                if (type !== types_1.DataType.pong) {
                    this.handleAllData(data);
                }
                switch (type) {
                    case types_1.DataType.pong:
                        this.heartbeatWebSocket.handleData(data.data);
                        break;
                    case types_1.DataType.exchangeOrder:
                        return this.handleExchangeOrder(data.data);
                    case types_1.DataType.botOrder:
                        return this.handleBuOrder(data.data);
                    case types_1.DataType.pionex_wallet:
                        return this.handleDWData(data.data);
                    case types_1.DataType.pionex_trigger:
                        return this.handleTriggerOrder(data.data);
                    case types_1.DataType.pionex_online_notify:
                        return this.handleOnlineNotify(data.data);
                    case types_1.DataType.swapx_balance:
                        return this.handleSwapxBalance(data.data);
                    case types_1.DataType.swapx_transaction:
                        return this.handleSwapxTransaction(data.data);
                    case types_1.DataType.leverage:
                        return this.handleLeverageChange(data.data);
                    default:
                        break;
                }
                return (0, rxjs_1.of)(undefined);
            }));
        }, { name: "AccountWebSocket" }).subscribe();
    }
    getExchangeOrderObservable() {
        return this.createDataObservable(types_1.DataType.exchangeOrder);
    }
    getBotOrderObservable() {
        return this.createDataObservable(types_1.DataType.botOrder);
    }
    getSmartTriggerOrderObservable() {
        return this.createDataObservable(types_1.DataType.botOrder).pipe((0, operators_1.filter)((item) => {
            return smartTriggerOrderTypeList.includes(item.bu_order_type);
        }));
    }
    getAnnouncementObservable() {
        return this.createDataObservable(types_1.DataType.announcement);
    }
    getDWObservable() {
        return this.createDataObservable(types_1.DataType.pionex_wallet);
    }
    getTriggersObservable() {
        return this.createDataObservable(types_1.DataType.pionex_trigger);
    }
    getOnlineNotifyObservable() {
        return this.createDataObservable(types_1.DataType.pionex_online_notify);
    }
    getSwapXBalanceObservable() {
        return this.createDataObservable(types_1.DataType.swapx_balance);
    }
    getSwapXTransactionObservable() {
        return this.createDataObservable(types_1.DataType.swapx_transaction);
    }
    getLeverageChangeObservable() {
        return this.createDataObservable(types_1.DataType.leverage);
    }
    getAllDataObservable() {
        return this.createDataObservable(types_1.DataType.all);
    }
    handleExchangeOrder(data) {
        const exchangeOrder = TradeUtils_1.TradeUtils.convertToExchangeOrder(data);
        // FIX 避免发送undefined到应用层
        if (exchangeOrder) {
            this.emitData(types_1.DataType.exchangeOrder, exchangeOrder);
        }
        return (0, rxjs_1.of)(undefined);
    }
    handleBuOrder(data) {
        if (smartTriggerOrderTypeList.includes(data.bu_order_type)) {
            this.emitData(types_1.DataType.botOrder, data);
            return (0, rxjs_1.of)(undefined);
        }
        const exchangeOrder = TradeUtils_1.TradeUtils.convertToExchangeOrder(data);
        if (!exchangeOrder) {
            return (0, rxjs_1.of)(undefined);
        }
        this.emitData(types_1.DataType.botOrder, exchangeOrder);
        return (0, rxjs_1.of)(undefined);
    }
    handleDWData(data) {
        const dwInfo = {
            id: data.tx_id,
            txId: data.tx_hash,
            currency: data.coin,
            timestamp: data.timestamp,
            internal: data.tx_hash.startsWith("pionex"),
            type: data.tx_type === "DEPOSIT" ? "deposit" : "withdraw",
            amount: data.amount,
            confirmations: data.confirmations,
            statusInner: data.tx_status,
            fee: data.fee,
            tag: data.tag,
            address: data.address,
            status: DWUtils_1.DWUtils.convertState(data.tx_status),
            canCancel: data.tx_status === TradeTypeDef_1.WithdrawRecordStatus.APPLIED || data.tx_status === TradeTypeDef_1.WithdrawRecordStatus.SHORTAGE,
            approvalReason: "approval_reason" in data
                ? data.reason
                : data.tx_status === TradeTypeDef_1.WithdrawRecordStatus.HICOIN_REJECTED
                    ? TradeTypeDef_1.WITHDRAW_REJECT_REASON.walletRejected
                    : undefined,
        };
        this.emitData(types_1.DataType.pionex_wallet, dwInfo);
        return (0, rxjs_1.of)(undefined);
    }
    handleAnnouncement(data) {
        this.emitData(types_1.DataType.announcement, data);
    }
    handleTriggerOrder(data) {
        this.emitData(types_1.DataType.pionex_trigger, data);
        return (0, rxjs_1.of)(undefined);
    }
    handleOnlineNotify(data) {
        this.emitData(types_1.DataType.pionex_online_notify, data);
        return (0, rxjs_1.of)(undefined);
    }
    handleSwapxBalance(data) {
        this.emitData(types_1.DataType.swapx_balance, data);
        return (0, rxjs_1.of)(undefined);
    }
    handleSwapxTransaction(data) {
        this.emitData(types_1.DataType.swapx_transaction, data);
        return (0, rxjs_1.of)(undefined);
    }
    handleLeverageChange(data) {
        this.emitData(types_1.DataType.leverage, data);
        return (0, rxjs_1.of)(undefined);
    }
    handleAllData(data) {
        this.emitData(types_1.DataType.all, data);
        return (0, rxjs_1.of)(undefined);
    }
    reportState() {
        if (!this.config.stateCallback) {
            return;
        }
        this.config.stateCallback(this.connectionState, this.getBaseStateMessage());
    }
}
exports.AccountWebSocket = AccountWebSocket;
